import type { UseApiLoaderResponse } from "../../server/api/hooks/use-api-loader";
import { useApiLoader } from "../../server/api/hooks/use-api-loader";
import { Waiting } from "../../server/supabase/hooks/use-supabase-loader";
import { useClaims } from "../generic/hooks/use-claims";
import { useGetDesignHuddleAccessToken } from "./use-design-huddle-access-token";

/**
 * this hook provides the user with user-level access to design huddle,
 * and access to either a specific project, or all their organizations projects
 */
export function useDesignHuddle(projects: string[]): UseApiLoaderResponse<{ success: boolean }> {
  const user = useClaims();
  const getAccessToken = useGetDesignHuddleAccessToken();

  return useApiLoader(async () => {
    if (!user) throw new Waiting();
    const token = await getAccessToken(projects);
    DSHDLib.configure({
      access_token: token,
      visitor: false,
    });

    return { success: true };
  }, [projects, getAccessToken, user]);
}
